import { fetchAddressDetails } from "../../../utils/fetchAddressDetails";
import { fetchCocDetails } from "../../../utils/fetchCocDetails";

type GenericInputEvent = { target: HTMLInputElement };

function getInputValue(name: string, formElements: HTMLFormControlsCollection) {
  const el = formElements.namedItem(name);

  if (el instanceof HTMLInputElement) {
    return el.value;
  }

  return "";
}

function setInputValue(
  name: string,
  value: string,
  formElements: HTMLFormControlsCollection
) {
  if (!value) {
    return;
  }

  const el = formElements.namedItem(name);

  if (el instanceof HTMLInputElement) {
    el.value = value;
  }
}

function getFormElements(el: HTMLInputElement) {
  return el.closest("form")?.elements;
}

export function getAddressDetailsEvent(endpoint: string) {
  return async (e: GenericInputEvent) => {
    const formElements = getFormElements(e.target);

    if (!formElements) {
      return;
    }

    const houseNumber = getInputValue("address.houseNumber", formElements);
    const zip = getInputValue("address.zip", formElements);

    if (!houseNumber || !zip) {
      return;
    }

    const { streetName, city } = await fetchAddressDetails(
      endpoint,
      zip,
      houseNumber
    );

    if (streetName) {
      setInputValue("address.street", streetName, formElements);
    }
    if (city) {
      setInputValue("address.city", city, formElements);
    }
  };
}

export function getCocDetailsEvent(endpoint: string) {
  return async (e: GenericInputEvent) => {
    const formElements = getFormElements(e.target);

    if (!formElements) {
      return;
    }

    const cocNumber = getInputValue("chamberOfCommerce", formElements);
    if (!cocNumber) {
      return;
    }

    const { isValid, name, address } = await fetchCocDetails(
      endpoint,
      cocNumber
    );

    if (!isValid) {
      return;
    }

    if (name) {
      setInputValue("name", name, formElements);
    }

    if (address) {
      setInputValue("address.zip", address.zip, formElements);
      setInputValue("address.houseNumber", address.houseNumber, formElements);
      setInputValue(
        "address.houseNumberAddition",
        address.houseNumberAddition,
        formElements
      );
      setInputValue("address.street", address.street, formElements);
      setInputValue("address.city", address.city, formElements);
    }
  };
}
